export default __webpack_public_path__ + "static/media/situation-mention-span.7e9bcb23.gif";